import cn from 'classnames';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { changeStaff } from '../../../actions/staff';
import UserApi from '../../../API/user/user-api';
import unarchive from '../../../assets/media/unarchive.svg';
import { Column, Row } from '../../../components/Basic/Blocks';
import { Button } from '../../../components/Basic/Buttons';
import { Icon } from '../../../components/Basic/Elements';
import { Content } from '../../../components/Basic/Global';
import { HeaderTitle, Table, TableCell, TableHeader, TableLine } from '../../../components/Basic/Table';
import { H1, Text, TextGrey } from '../../../components/Basic/WrapsStyle';
import { ALL_USERS, TO_PROFILE } from '../../../constans';
import { NAVIGATION } from '../../../routers/routes';
import styles from './styles.module.scss';

const width = ['40px', '180px', '80px', '150px', '500px', '500px', '470px', '550px'];

function UsersArchivePage() {
  const dispatch = useDispatch();

  const staff = useSelector((store) => store.staff);

  // const packer = staff.filter((user) => user.role === 'packer');
  // const sorter = staff.filter((user) => user.role === 'sorter');

  const sorted = staff.filter(user => user.archive?.status);

  return (
    <>
      <Content>
        <Row style={{ alignItems: 'flex-start' }}>
          <Column>
            <H1>Сотрудники склада (Архив)</H1>
            <Table style={{ width: '1600px' }}>
              <TableHeader whiteHeader={true}>
                <HeaderTitle width={width[0]}>№</HeaderTitle>
                <HeaderTitle width={width[1]}>Логин</HeaderTitle>
                <HeaderTitle width={width[3]} centerText>
                  Роль
                </HeaderTitle>
                <HeaderTitle width={width[2]} centerText>
                  Scanner Id
                </HeaderTitle>
                <HeaderTitle width={width[4]}>Доступы</HeaderTitle>
                <HeaderTitle width={width[1]} centerText>Дата переноса в архив</HeaderTitle>
                <HeaderTitle width={width[5]} rightText />
              </TableHeader>
              {sorted.map((item, key) => (
                <TableLine key={key}>
                  <TableCell width={width[0]}>{key + 1}</TableCell>
                  <TableCell width={width[1]}>
                    <Column>
                      <Link to={TO_PROFILE(item._id)} className={styles.link}>
                        <div style={{ fontWeight: '600' }}>{item.name}</div>
                      </Link>

                      <TextGrey>{item.login}</TextGrey>
                    </Column>
                  </TableCell>
                  <TableCell width={width[3]} center>
                    <div
                      className={cn(
                        styles.status,
                        ALL_USERS[item.role].name === ALL_USERS.owner.name && styles.sold,
                        ALL_USERS[item.role].name === ALL_USERS.admin.name && styles.sorted,
                        ALL_USERS[item.role].name === ALL_USERS.user.name && styles.pickup,
                        ALL_USERS[item.role].name === ALL_USERS.packer.name && styles.canceled_by_client,
                        ALL_USERS[item.role].name === ALL_USERS.sorter.name && styles.sorted,
                        ALL_USERS[item.role].name === ALL_USERS.content.name && styles.content,
                        ALL_USERS[item.role].name === ALL_USERS.booker.name && styles.booker,
                      )}
                    >
                      {ALL_USERS[item.role].name}
                    </div>
                  </TableCell>
                  <TableCell width={width[2]} center>
                    {item.scanerId}
                  </TableCell>

                  <TableCell width={width[4]}>
                    <Text style={{ overflowWrap: 'anywhere' }}>
                      {
                        Object.entries(item.accesses || {})
                          .reduce((acc, [serviceName, accessesByService]) => {
                            Object.entries(accessesByService).forEach(([access, hasAccess]) => { if (hasAccess) acc.push(NAVIGATION?.[serviceName]?.routes.find(r => r.path === access)?.name) })
                            return acc
                          }, []).join(', ')
                      }
                    </Text>
                  </TableCell>
                  <TableCell center width={width[1]} style={{ alignItems: 'center' }}>
                    <Text fontSize={'16px'} fontWeight={'bold'}>{moment(item.archive?.date).format('HH:mm  YYYY-MM-DD')}</Text>
                  </TableCell>
                  <Button
                    onClick={() =>
                      UserApi.changeUser({ data: { login: item.login, data: { ...item, archive: { status: !item.archive?.status, date: item.archive?.date } } } })
                        .then((r) => {
                          dispatch(changeStaff(r.data.login, r.data));
                        })
                    }
                    disabled={item.role === 'owner'}
                    style={{ marginLeft: '20px' }}
                  >
                    <Icon src={unarchive} width="20px" height={'20px'} style={{ marginRight: '30px', marginBottom: '7px' }} />
                  </Button>
                  <TableCell width={width[4]} style={{ alignItems: 'center' }}></TableCell>
                </TableLine>
              ))}
            </Table>
          </Column>
        </Row>
      </Content>
    </>
  );
}

export default UsersArchivePage;
